import { CreateVoice, GetListResponse, Voice } from "@app/types";
import HttpService from "@core/services/http/http.service";
import {
  RequestContentType,
  RequestParams,
  Signal,
} from "@core/services/http/http.type";

class _VoiceService {
  public getList(requestParams?: RequestParams, signal?: Signal) {
    return HttpService.get<GetListResponse<Voice>>(
      "/admin/api/v2/voice-trains",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public create(createVoice: CreateVoice) {
    return HttpService.post("/admin/api/v2/voice-trains", {
      body: { ...createVoice },
      requestContentType: RequestContentType.MULTIPART,
    });
  }

  public update(voiceId: number, createVoice: CreateVoice) {
    return HttpService.patch(`/admin/api/v2/voice-trains/${voiceId}`, {
      body: { ...createVoice },
      requestContentType: RequestContentType.MULTIPART,
    });
  }

  public delete(voiceId: number) {
    return HttpService.delete(`/admin/api/v2/voice-trains/${voiceId}`);
  }
}

const VoiceService = new _VoiceService();

export default VoiceService;
